module.exports = __webpack_public_path__ + "static/media/blog4.c96f681a.jpg";